"use strict";
const angular = require("angular");
import _ from "lodash";

export class PatientDetailsPopupController {
  /*@ngInject*/
  constructor(
    appConfig,
    $rootScope,
    $uibModalInstance,
    $uibModal,
    $state,
    $http,
    moment,
    patient,
    incidentType,
    ngToast
  ) {
    "ngInject";

    this.incidentType = incidentType;
    this.severities = appConfig.severities;
    this.message = "Hello";
    this.modal = $uibModalInstance;
    this.$uibModal = $uibModal;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$state = $state;
    this.moment = moment;
    this.ngToast = ngToast;

    this.patient = patient;
  }

  save() {
    let p = _.clone(this.patient);
    if (p.complaintInjury) {
      p.complaintInjury = p.complaintInjury.toString();
    }
    if (p.assessedInjury) {
      p.assessedInjury = p.assessedInjury.toString();
    }
    this.$http.put(`/api/patients/${p.id}`, p).then(
      () => {
        this.modal.close({ type: "add", patient: p });
      },
      error => {
        this.ngToast.create({
          className: "danger",
          content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
        });
        console.log(error);
      }
    );
  }

  delete() {
    var modalScope = this.$rootScope.$new();
    const patient = this.patient;
    angular.extend(modalScope, { patient });

    modalScope.$uibModalInstance = this.$uibModal.open({
      animation: false,
      template: require("./deletePatient.html"),
      scope: modalScope
    });

    modalScope.$uibModalInstance.result.then(() => {
      console.log("delete: ", this.patient);
      this.$http.delete(`/api/patients/${this.patient.id}`).then(
        () => {
          this.modal.close({ type: "delete", patient: this.patient });
        },
        error => {
          this.ngToast.create({
            className: "danger",
            content: `Error: An error occured: ${error.data.name}: ${error.data.message}`
          });
        }
      );
    });
  }
}

export default angular
  .module("hccApp.patientDetailsPopup", [])
  .controller("PatientDetailsPopupController", PatientDetailsPopupController)
  .name;



// WEBPACK FOOTER //
// ./client/app/incident/patient/patientDetails/patientDetailsPopup.controller.js